module.exports = __webpack_public_path__ + "static/media/app_planning_v3.843d41c7.svg";